import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteIcon from '@mui/icons-material/Delete';

const ActionRenderer = ({  onDelete , handleViewCLick}) => {

    return (
        <div style={{ display: "flex", gap: "8px" }}>
            <span
                style={{ cursor: "pointer", color: "#254a9a" }}
                onClick={handleViewCLick }
            >
                  <VisibilityIcon /> 
            </span>
            {/* <span
                style={{ cursor: "pointer", color: "#aa3939" }}
                onClick={onDelete}
            >
                <DeleteIcon />
            </span> */}
        </div>
    );
};

export default ActionRenderer;